import React, { useEffect, useRef } from 'react';
import { useInView, animate } from 'framer-motion';
function Counter({
  from,
  to,
  decimals = 0,
  prefix = '',
  suffix = ''
}: {
  from: number;
  to: number;
  decimals?: number;
  prefix?: string;
  suffix?: string;
}) {
  const nodeRef = useRef<HTMLSpanElement>(null);
  const inView = useInView(nodeRef, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (inView && nodeRef.current) {
      const controls = animate(from, to, {
        duration: 1.5,
        ease: 'easeOut',
        onUpdate(value) {
          if (nodeRef.current) {
            nodeRef.current.textContent = prefix + value.toFixed(decimals) + suffix;
          }
        }
      });
      return () => controls.stop();
    }
  }, [from, to, inView, prefix, suffix, decimals]);
  return <span ref={nodeRef} data-id="element-235">
      {prefix}
      {from.toFixed(decimals)}
      {suffix}
    </span>;
}
export function ProofBar() {
  const stats = [{
    from: 0,
    to: 500,
    prefix: '+',
    label: 'Veterinarios'
  }, {
    from: 0,
    to: 4.9,
    decimals: 1,
    label: 'Rating'
  }, {
    from: 0,
    to: 8,
    label: 'Tomos completos'
  }, {
    from: 0,
    to: 7,
    suffix: ' días',
    label: 'Para notarlo'
  }];
  return <div className="bg-navy py-4 sm:py-5 px-5 border-y border-white/5" data-id="element-236">
      <div className="flex flex-wrap justify-center gap-6 sm:gap-12" data-id="element-237">
        {stats.map((stat, i) => <div key={i} className="text-center" data-id="element-238">
            <div className="font-display text-xl sm:text-3xl font-bold text-gold-light" data-id="element-239">
              <Counter from={stat.from} to={stat.to} decimals={stat.decimals} prefix={stat.prefix} suffix={stat.suffix} data-id="element-240" />
            </div>
            <div className="text-[10px] sm:text-xs text-white/55 uppercase tracking-wider mt-0.5 sm:mt-1" data-id="element-241">
              {stat.label}
            </div>
          </div>)}
      </div>
    </div>;
}